/**
 * Typical architectural drawing scales for the Review scale calibrator.
 * `input` strings are parsed by parseCalibrationInput / parseScaleRatio.
 */

export const CUSTOM_SCALE_PRESET_ID = 'custom';

export const IMPERIAL_SCALE_PRESETS = [
  { id: 'imp-3-32', label: '3/32" = 1\'-0"', input: '3/32" = 1\'-0"' },
  { id: 'imp-1-16', label: '1/16" = 1\'-0"', input: '1/16" = 1\'-0"' },
  { id: 'imp-3-16', label: '3/16" = 1\'-0"', input: '3/16" = 1\'-0"' },
  { id: 'imp-1-8', label: '1/8" = 1\'-0"', input: '1/8" = 1\'-0"' },
  { id: 'imp-1-4', label: '1/4" = 1\'-0"', input: '1/4" = 1\'-0"' },
  { id: 'imp-3-8', label: '3/8" = 1\'-0"', input: '3/8" = 1\'-0"' },
  { id: 'imp-1-2', label: '1/2" = 1\'-0"', input: '1/2" = 1\'-0"' },
  { id: 'imp-1', label: '1" = 1\'-0"', input: '1" = 1\'-0"' },
  { id: 'imp-1-1', label: '1" = 1"', input: '1:1' },
  { id: 'imp-1-4in', label: '1/4" = 1"', input: '1/4" = 1"' },
];

export const METRIC_SCALE_PRESETS = [
  { id: 'met-1', label: '1:1', input: '1:1' },
  { id: 'met-5', label: '1:5', input: '1:5' },
  { id: 'met-10', label: '1:10', input: '1:10' },
  { id: 'met-20', label: '1:20', input: '1:20' },
  { id: 'met-25', label: '1:25', input: '1:25' },
  { id: 'met-50', label: '1:50', input: '1:50' },
  { id: 'met-75', label: '1:75', input: '1:75' },
  { id: 'met-100', label: '1:100', input: '1:100' },
  { id: 'met-200', label: '1:200', input: '1:200' },
  { id: 'met-500', label: '1:500', input: '1:500' },
  { id: 'met-1000', label: '1:1000', input: '1:1000' },
];

export const SCALE_PRESET_GROUPS = [
  { id: 'imperial', label: 'Imperial (architectural)', presets: IMPERIAL_SCALE_PRESETS },
  { id: 'metric', label: 'Metric', presets: METRIC_SCALE_PRESETS },
];

export function findPresetByInput(input) {
  const normalized = String(input || '').trim().toLowerCase();
  if (!normalized) return null;
  for (const group of SCALE_PRESET_GROUPS) {
    const hit = group.presets.find(
      (p) => p.input.trim().toLowerCase() === normalized
        || p.label.trim().toLowerCase() === normalized,
    );
    if (hit) return hit;
  }
  return null;
}

export function presetSelectOptions() {
  const options = [];
  for (const group of SCALE_PRESET_GROUPS) {
    for (const preset of group.presets) {
      options.push({
        ...preset,
        groupLabel: group.label,
        optionLabel: `${group.label} — ${preset.label}`,
      });
    }
  }
  options.push({
    id: CUSTOM_SCALE_PRESET_ID,
    label: 'Custom…',
    input: '',
    groupLabel: 'Other',
    optionLabel: 'Custom…',
  });
  return options;
}
